module.exports = __webpack_public_path__ + "img/49.27ee9bde.jpg";